module.exports = __webpack_public_path__ + "img/example_2_icon.9748e5fe.png";